<template>
    <div class="page-banner page-content" v-loading="body_loading">
        <div class="main-body">
            <!-- <el-row class="hd">
                <el-col :span="12">
                    <h3 style="float: none;">首页banner</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>banner管理</el-breadcrumb-item>
                            <el-breadcrumb-item>首页banner</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
                <el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
                    <el-button type="primary" class="btn-bg-p" @click="handleBanner('add')">添加 <i class="el-icon-plus"></i></el-button>
                    <el-button type="primary" class="btn-bg-r" @click="delmultiple()">批量删除</el-button>
                </el-col>
            </el-row> -->
            <div class="bd form-panel">
             <el-form ref="formVideo" :model="dlg_video.form" label-width="100px" :rules="dlg_video.rules" @submit.native.prevent>
				 
				 <div class="video-title" @click="getFeedTaskDetail('veoc761107a871f405bb26c6fa901aa74fbbksv')">
				 	视频参数设置
				 </div>
				              
				  
				  <el-form-item prop="prompt" label="视频描述：" :error="dlg_video.error.prompt">
				       <textarea class="styled-textarea" rows="30"
				       							  placeholder="请输入您的视频创意描述..." v-model="dlg_video.form.prompt"></textarea>
				  </el-form-item>
				 <!-- <el-form-item prop="detail" label="详细脚本：" :error="dlg_video.error.detail">
				       <textarea class="styled-textarea" rows="4" 
				       				             placeholder="输入分镜脚本（每行一个场景）..." v-model="dlg_video.form.detail"></textarea>
				  </el-form-item> -->
                 <el-form-item prop="image_url" style="margin-top: 15px;" label="素材：" :error="dlg_video.error.image_url">
                     <el-upload
                             :action="dlg_video.params.action"
                             :headers="dlg_video.params.headers"
                             :data="dlg_video.params.data"
                             accept="*"
                             :class="dlg_video.hide_upload?'hide-upload head-upload':'head-upload'"
                             list-type="picture-card"
                             :file-list="dlg_video.img_list"
                             name="file"
                             :on-preview="(file) => {dlg_preview.img_url = file.url;dlg_preview.visible = true;}"
                             :on-remove="removeImg"
                             :on-success="uploadSuccessImg">
                         <i class="el-icon-plus"></i>
                     </el-upload>
                     <p class="img-tips">素材大小：（请上传小于5M的素材）</p>
                 </el-form-item>
				<!-- <el-form-item prop="template_id" label="场景风格：" :error="dlg_video.error.template_id">
				    <select class="styled-select" id="sceneSelect" v-model="dlg_video.form.template_id">
				        <option value="">选择运镜模板</option>
				        <option value="hitchcock_dolly_in">希区柯克推进</option>
				        <option value="hitchcock_dolly_out">希区柯克拉远</option>
				        <option value="robo_arm">机械臂</option>
				        <option value="dynamic_orbit">动感环绕</option>
				        <option value="central_orbit">中心环绕</option>
				        <option value="crane_push">起重机</option>
				        <option value="quick_pull_back">超级拉远</option>
				        <option value="counterclockwise_swivel">逆时针回旋</option>
				        <option value="clockwise_swivel">顺时针回旋</option>
				        <option value="handheld">手持运镜</option>
						<option value="rapid_push_pull"> 快速推拉</option>
				    </select>
				</el-form-item> -->
				<!-- <el-form-item prop="camera_strength" label="视频强度：" :error="dlg_video.error.camera_strength">
				    <select class="styled-select" id="styleSelect" v-model="dlg_video.form.camera_strength" >
				        <option value="">选择视频强度</option>
				        <option value="weak">弱</option>
				        <option value="medium">中</option>
				        <option value="strong">强</option>
				       
				    </select>
				</el-form-item> -->
				<el-button type="primary" class="generate-btn" @click="generateVideo()" :loading="dlg_video.btn_loading">生成视频</el-button>
				
				 <!-- <button class="generate-btn" @click="generateVideo()">生成视频</button> -->
             </el-form>
               
            </div>
			<div class="video">
				<!-- 右侧预览 -->
				<video id="video-output" :src="dlg_video.generateVideoUrl" progress="正在生成中" controls></video>
				
				
			</div>
        </div>
      
       <el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
            <img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            var valiImg = (rule, value, callback) =>
            {
                if (!this.dlg_video.hide_upload) {
                    callback(new Error("请上传视频素材"));
                } else {
                    callback();
                }
            };
            return {
				pollTimer:null,
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
                baseUrl:this.$client.IMG_URL,
                //搜索
                form_search:{
                    name:"",
                    status: -1
                },
                init_data: {
                    status_list: [{id:-1, name: '全部'},{id:0, name: '禁用'},{id:1, name: '启用'}],
                },
                multipleSelection: [],
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 30,
                        total: 130
                    }
                },
                dlg_video:{
                    id:'',
                    visible:false,
                    btn_loading:false,
                    api: 'https://veo3api.com/generate',
                    title:'',
                    hide_upload: false,
                    img_list: [],
					generateVideoUrl:"",
                    form:{
						original_task_id:'veo302edea606f44303890a10dc790d8394bksv',
						task_id:'',
                        image_url:'',
						image_urls:'',
                        
                        prompt:'',
      //                   detail:'',
						// template_id:'',
						camera_strength:'',
						aspect_ratio:'',
						model: "veo3-fast",
						watermark: null
                    },
                    error:{
                        image_url:'',
                        
                       prompt:'',
                        detail:'',
                       	template_id:'',
                       	camera_strength:''
                    },
                    reset_form: {},
                    init_data:{
                        status_list: []
                    },
                    rules:{
                       // image_url:{required: true, validator: valiImg},
                        prompt:{required: true, message: '请输入视频描述', trigger: ['change','blur']},
						detail:{required: true, message: '请输入详细脚本', trigger: ['change','blur']},
						template_id:{required: true, message: '请选择场景风格', trigger: ['change','blur']},
						camera_strength:{required: true, message: '请选择视频风格', trigger: ['change','blur']},
                        status:{required: true, message: '请选择状态', trigger: ['change','blur']},
                    },
                    params:{
                        action: this.$client.API_URL+'/api/sys/file/upload',
                        data:{path:'aivideo'},
                        headers:{token:localStorage.getItem('token')}
                    }
                },
                dlg_preview:{
                    visible: false,
                    img_url: ''
                }
            }
        },
        created() {
            document.title = 'ai生成视频';
            this.dlg_video.reset_form = Object.assign({}, this.dlg_video.form);
			if(this.dlg_video.form.task_id){
			}
			//	this.getFeedTaskDetail('veo302edea606f44303890a10dc790d8394bksv')
				//
            // this.getList();
        },
        methods: {
           
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            uploadSuccessImg(res, file, fileList){
                this.dlg_video.img_list = fileList;
				this.dlg_video.form.image_url = res.data.icode;  
				this.dlg_video.form.image_urls = this.baseUrl +'/api/sys/file/download?attachId='+res.data.icode;
                this.dlg_video.hide_upload = true;
            },
            removeImg(file, fileList){
                this.dlg_video.form.image_url = '';
                this.dlg_video.img_list = [];
                this.dlg_video.hide_upload = false;
            },
            generateVideo(){
                var _this = this;
                _this.$refs['formVideo'].validate((valid) => {
                    if (valid && this.dlg_video.form.task_id =='' ) {
                        this.dlg_video.btn_loading = true;
                        this.$client.post('/api/sys/veo3/generate', this.dlg_video.form, function(res,message){
                            console.log(res)
                            _this.$message(message);
							console.log(res)
							_this.dlg_video.form.task_id=res.task_id
                            _this.dlg_video.btn_loading = true;
                            _this.dlg_video.visible = true;
							_this.getFeedTaskDetail(res.task_id)
                        }, function(message){
                            _this.dlg_video.btn_loading = false;
							
							
							
                            // if((typeof message)==='object'){
                            //     for(var key in message){
                            //         _this.dlg_video.error[key] = message[key];
                            //     }
                            // }
                        });
                    } else if(valid && this.dlg_video.form.task_id){
                       this.dlg_video.btn_loading = true;
					 
                       this.$client.post('/api/sys/veo3/extend', this.dlg_video.form, function(res,message){
                           console.log(res)
                           _this.$message(message);
                          
                           _this.dlg_video.btn_loading = false;
                           _this.dlg_video.visible = false;
						    	_this.dlg_video.form.task_id=res.task_id
						   _this.dlg_video.form.original_task_id=res.original_task_id
						   	_this.getFeedTaskDetail(res.task_id)
							
                       }, function(message){
                           _this.dlg_video.btn_loading = false;
                      
                       
                       	
                       	
                           // if((typeof message)==='object'){
                           //     for(var key in message){
                           //         _this.dlg_video.error[key] = message[key];
                           //     }
                           // }
                       });
					}else {
								console.log('error submit!!');
						return false;
					}
            });
            },
			// async getFeedTaskDetail(task_id) {
			//     const _this = this;
			    
			//     try {
			//         const res = await this.$client.get('/api/sys/veo3/feed?task_id=' + task_id);
			//         console.log(res,"请求结果");
			        
			//         if (res.response != null && res.response && Array.isArray(res.response) && res.response.length > 0) {
			//             // 成功
			//             _this.dlg_video.generateVideoUrl = res.response[0];
			//             _this.dlg_video.btn_loading = false;
			//             _this.dlg_video.visible = false;
			//             // 清除定时器
			//             if (_this.pollTimer) clearInterval(_this.pollTimer);
			//         } else {
			//             // 未完成，继续轮询
			//             _this.dlg_video.btn_loading = true;
			//             if (_this.pollTimer) clearInterval(_this.pollTimer); // 防止叠加
			            
			//             _this.pollTimer = setInterval(() => {
			//                 _this.getFeedTaskDetail(task_id);
			//             }, 5000);
			//         }
			//     } catch (error) {
			//         _this.dlg_video.btn_loading = false;
			//         if (_this.pollTimer) clearInterval(_this.pollTimer);
			//     }
			// },
			getFeedTaskDetail(task_id){
				var _this = this;
				this.$client.get('/api/sys/veo3/feed?task_id='+task_id, '', function(res,message){
				    console.log(res)
				 //  _this.$message(message);
					if(res.response !=null && res.response && Array.isArray(res.response) && res.response.length > 0){
						
						_this.dlg_video.generateVideoUrl=res.response[0]
						
						_this.dlg_video.btn_loading = false;
						_this.dlg_video.visible = false;
						// 清除定时器
						if (_this.pollTimer) clearInterval(_this.pollTimer);
					}else{
						_this.dlg_video.btn_loading = true;
						if (_this.pollTimer) clearInterval(_this.pollTimer); // 防止叠加
						
						_this.pollTimer = setInterval(() => {
						    _this.getFeedTaskDetail(task_id);
						}, 5000);
						
						// _this.dlg_video.visible = false;
					}
					
					
				}, function(message){
				    _this.dlg_video.btn_loading = false;
					if (_this.pollTimer) clearInterval(_this.pollTimer);
				    
				});
			},
            closeBanner(){
                this.dlg_video.img_list = [];
                this.dlg_video.hide_upload = false;
                for(var key in this.dlg_video.form){
                    this.dlg_video.form[key] = this.dlg_video.reset_form[key];
                }
                this.$nextTick(()=>{
                    this.$refs.formVideo.clearValidate();
            })
            },
            changeFixed(clientHeight){
              //  this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
           // this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                //this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
        }
    }
</script>
<style>
    .page-banner .el-upload--picture-card{
        line-height: 80px;
    }
    .page-banner .el-upload--picture-card,.el-upload-list--picture-card .el-upload-list__item{
        width: 80px;
        height: 80px;
    }
    .hide-upload .el-upload--picture-card {
        display: none;
    }
</style>
<style scoped >
	.main-body{
		background-color: #fff;
		display: flex;
		flex-direction: row;
		justify-content: center;
		
	}
	.bd{
		
	}
	.video{
		margin-top: 50px;
	}
	
	.video-title{
		font-size: 30px;
		display: flex;
		flex-direction: row;
		justify-content: center;
		margin-bottom: 20px;
	}
	/* 桌面端布局 */
	.form-panel, .preview-panel {
	    width: 40vw;
	    background: rgba(255, 255, 255, 0.05);
	    backdrop-filter: blur(10px);
	    border-radius: 15px;
	    padding: 25px;
	    border: 1px solid rgba(255, 255, 255, 0.1);
	}
	
	.preview-panel {
	    position: relative;
	    display: flex;
	    align-items: center;
	    justify-content: center;
	}
	
	.preview-panel::before {
	    content: "请先填写描述文字和设置视频参数";
	    position: absolute;
	    color: rgba(255,255,255,0.3);
	    font-size: 1.2em;
	    text-align: center;
	    padding: 20px;
	}
	
	/* 移动端布局 */
	@media (max-width: 768px) {
	    .container {
	        flex-direction: column;
	        padding: 10px;
	    }
	    
	    .preview-panel {
	        min-height: 50vh;
	    }
	}
	
	.upload-box {
	    border: 2px dashed var(--secondary);
	    padding: 20px;
	    text-align: center;
	    border-radius: 10px;
	    margin: 15px 0;
	    transition: all 0.3s ease;
	}
	
	.upload-box:hover {
	    background: rgba(108, 92, 231, 0.1);
	    border-color: var(--primary);
	}
	
	input[type="file"] {
	    display: none;
	}
	.styled-textarea{
		width: 100%;
	
		padding: 4px;
		background: rgba(0,0,0,0.1);
		border: 1px solid rgba(0,0,0,0.2);
		border-radius: 8px;
		
		color:#4f4747;
		/* margin: 10px 0; */
	}
	.styled-select {
	    width: 100%;
	    padding: 12px;
	    /* background: rgba(0,0,0,0.1); */
		color: #333;
	    border: 1px solid rgba(0,0,0,0.2);
	    border-radius: 8px;
	    /* color: #fff; */
	   /* margin: 10px 0; */
	}
	
	.generate-btn {
	    background: #6c5ce7;
	    color: white;
	    border: none;
	    padding: 15px 30px;
	    border-radius: 8px;
	    width: 100%;
	    cursor: pointer;
	    font-size: 1.1em;
	    transition: transform 0.2s ease;
	}
	
	.generate-btn:hover {
	    transform: translateY(-2px);
	}
	
	#video-output {
		/* margin-top: 20px; */
		margin-left: 10px;
	    width: 30vw;
	    height: 50vh;
	    border-radius: 10px;
		border: 1px #e7e5e5 solid
	}
	
	.loading-wave {
	    height: 3px;
	    background: linear-gradient(90deg, transparent 0%, var(--primary) 50%, transparent 100%);
	    animation: loading 1.5s infinite;
	    display: none;
	}
	
	@keyframes loading {
	    0% { background-position: -200px 0; }
	    100% { background-position: 200px 0; }
	}
    .img-tips{
        color: #f31a5c;
        font-size: 12px;
    }
</style>